import React from "react";
import { useLocation } from "react-router-dom";
import "./DashboardHeader.css";

const DashboardHeader: React.FC = () => {
  const location = useLocation();

  const getTitle = (): string => {
    if (location.pathname === "/dashboard") {
      return "Dashboard";
    }
    if (location.pathname === "/dashboard/account") {
      return "< Account Details";
    }
    if (location.pathname === "/dashboard/schedule_consultation") {
      return "< Schedule Your Consult";
    }
    if (location.pathname === "/dashboard/book_appointment") {
      return "< Schedule Your Consult";
    }
    if (location.pathname === "/dashboard/appointment_booked") {
      return "< Appointment";
    }
    return "";
  };

  return (
    <header className="dashboard-header">
      <div className="dashboard-title">
        <h2>{getTitle()}</h2>
      </div>
      <button className="logout-button">Logout</button>
    </header>
  );
};

export default DashboardHeader;
